<template>
  <div class="container-list"
    :class="{'container-list-width': !isMenuMiniSize, 'container-list-width-thin-menu': isMenuMiniSize}">
  >
    <ModalCreateRecord
      :isShowModal="isShowModalCreateRecord"
      :recordingInterviews="recordingInterviews"
      @create-recording-interview="createRecordingInterview"
      @cancel="changeModalCreateRecord"
      v-if="isShowModalCreateRecord"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalEditRecord
      :isShowModal="isShowModalEditRecord"
      :tempRecordingInterview="detailRecord"
      @update-recording-interview="updateRecordingInterview"
      @cancel="changeModalEditRecord"
      v-if="isShowModalEditRecord"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalDeleteRecord
      :isShowModal="isShowModalDeleteRecord"
      :recordingInterview="tempRecordingInterview"
      @delete-recording-interview="deleteRecordingInterview"
      @cancel="changeModalDeleteRecord"
      v-if="isShowModalDeleteRecord"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalAnswerRecord
      :isShowModal="isShowModalAnswerRecord"
      :recordingInterview="tempRecordingInterview"
      :answerRecord="answerRecord"
      :user="user"
      :users="users"
      :recruitmentFlows="recruitmentFlows"
      :isChangePageModalAnswerRecord="isChangePageModalAnswerRecord"
      @change-recruitment-flow="changeRecruitmentFlow"
      @update-recording-answer="updateRecordingAnswer"
      @update-recording-read-answer="updateRecordingReadAnswer"
      @update-recording-select-seeker="updateRecordingSelectSeeker"
      @cancel="changeModalAnswerRecord"
      @changePageModalAnswerRecord="changePageModalAnswerRecord"
      v-if="isShowModalAnswerRecord"
      :PCTRLLOG="CTRLLOG"
    />
    <div class="video-header">
      <h2 style="font-weight: 600">
        <span class="mdi mdi-camcorder-box" style="margin-right: 4px"></span>録画面接
      </h2>
    </div>
    <div class="recording-container disp-scroll" id="scroll">
      <div class="make-recording" @click="changeModalCreateRecord(true)">
        <p>+ 録画面接作成</p>
      </div>
      <template v-if="recordingInterviews.length > 0">
        <RecordingInterviewCard
          v-for="(record, idx) in recordingInterviews"
          :key="idx"
          :recordingInterview="record"
          :user="user"
          :changeModalAnswerRecord="changeModalAnswerRecord"
          @change-modal-edit-record="changeModalEditRecord"
          @change-modal-delete-record="changeModalDeleteRecord"
        />
      </template>
      <div id="loading-record" class="make-recording" v-if="isCreatingRecord">
        <p>
          <span class="mdi mdi-loading"></span>
          ファイルを作成中です。ファイルによっては数分～10数分かかることもございますのでご了承ください。
        </p>
      </div>
      <b-loading v-if="isLoading" :active="true" :is-full-page="false">
        ローディング中です。しばらくお待ちください。<span class="mdi mdi-loading mdi-spin"></span>
      </b-loading>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import createUUID from '@/functions/createUUID'
import ModalCreateRecord from '@/components/VideoView/organisms/ModalCreateRecord'
import ModalEditRecord from '@/components/VideoView/organisms/ModalEditRecord'
import ModalAnswerRecord from '@/components/VideoView/organisms/ModalAnswerRecord'
import ModalDeleteRecord from '@/components/VideoView/organisms/ModalDeleteRecord'
import RecordingInterviewCard from '@/components/VideoView/organisms/RecordingInterviewCard'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    ModalCreateRecord,
    ModalEditRecord,
    ModalAnswerRecord,
    ModalDeleteRecord,
    RecordingInterviewCard,
  },
  mixins: [
    controlLogMixin
  ],
  data() {
    return {
      COMPONENT_NAME: 'RecordView',
      isShowModalCreateRecord: false,
      isShowModalEditRecord: false,
      isShowModalDeleteRecord: false,
      isShowModalAnswerRecord: false,
      isCreatingRecord: false,
      tempRecordingInterview: null,
      cntContent: 0,
      isLoadingModalAnswerRecord: false,
      isChangePageModalAnswerRecord: false,
      isFirstLoading: true,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'recruitmentFlows']),
    ...mapState('directtalk', ['recordingInterviews', 'answerRecord', 'detailRecord']),
    ...mapState("setting",["isMenuMiniSize"]),
    isLoading() {
      if (this.isFirstLoading || this.isLoadingModalAnswerRecord) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
    this.initializeData()
  },
  methods: {
    async initializeData() {
      console.log('initializeData start') // デバッグログ追加
      try {
        // タイムアウト付きのPromise.race を使用
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('API Timeout')), 10000) // 10秒でタイムアウト
        })

        const apiCalls = Promise.all([
          this.$store.dispatch('auth/getRecruitmentFlow'),
          this.$store.dispatch('directtalk/getRecordingInterview', null)
        ])

        await Promise.race([apiCalls, timeoutPromise])
        
        console.log('API calls completed') // デバッグログ追加
        this.isFirstLoading = false
      } catch (error) {
        console.error('データ読み込みエラー:', error) // より詳細なエラーログ
        this.isFirstLoading = false
        // エラーをユーザーに表示
        this.$toast.error('データの読み込みに失敗しました。再読み込みしてください。')
      } finally {
        // 強制的にローディングを解除（安全策）
        setTimeout(() => {
          if (this.isFirstLoading) {
            console.warn('強制的にローディングを解除')
            this.isFirstLoading = false
          }
        }, 15000)
      }
    },
    scrollCreateRecording() {
      let parent = document.getElementById('scroll')
      let bottom = parent.scrollHeight - parent.clientHeight
      parent.scroll(0, bottom)
    },
    cntCreateLoading() {
      this.cntContent--
      if (this.cntContent === 0) {
        this.isCreatingRecord = false
      }
    },
    changeModalCreateRecord(flg) {
      if (this.recordingInterviews.length === 20) {
        alert(
          '録画面接は最大20本までしか作成できません。\n新しい録画面接を作成したい場合は他の録画面接を削除した後に作成してください。'
        )
        flg = false
      }
      this.isShowModalCreateRecord = flg
    },
    changeModalEditRecord(flg, data) {
      this.$store.dispatch('directtalk/getRecordingDetail', data.id).then(() => {
        this.tempRecordingInterview = this.$_.cloneDeep(data)
        this.isShowModalEditRecord = flg
      })
    },
    changeModalDeleteRecord(flg, data) {
      this.tempRecordingInterview = this.$_.cloneDeep(data)
      this.isShowModalDeleteRecord = flg
    },
    changeModalAnswerRecord(flg, data) {
      this.isLoadingModalAnswerRecord = true
      this.$store
        .dispatch('directtalk/getRecordingAnswer', { content: data.recording_content[0], page: 1 })
        .then(() => {
          this.isLoadingModalAnswerRecord = false
          this.tempRecordingInterview = this.$_.cloneDeep(data)
          this.isShowModalAnswerRecord = flg
        })
    },
    changePageModalAnswerRecord(data, data2) {
      this.isChangePageModalAnswerRecord = true
      this.$store
        .dispatch('directtalk/getRecordingAnswer', { content: data, page: data2 })
        .then(() => {
          this.isChangePageModalAnswerRecord = false
        })
        .catch(() => {
          this.isChangePageModalAnswerRecord = false
        })
    },
    createRecordingInterview(data) {
      let createData = {
        name: data.name,
        description: data.description,
        start_hhmm: moment(data.start_hhmm).format('HH:mm:ss'),
        end_hhmm: moment(data.end_hhmm).format('HH:mm:ss'),
        company: this.user.companyPK,
        total_limit_time: data.total_limit_time,
      }
      this.isCreatingRecord = true
      this.cntContent = data.recordingContent.length

      this.$store.dispatch('directtalk/createRecordingInterview', createData).then((d) => {
        console.log('録画面接作成成功:', d)  // デバッグログ追加
        
        this.$nextTick(() => {
          this.scrollCreateRecording()
        })

        // Promise.allを使用して全てのコンテンツの作成を待つ
        const contentPromises = data.recordingContent.map(content => {
          let createContent = new FormData()
          let newFile = new File(
            [content.question_recording],
            d.id + '-' + createUUID() + '-' + content.order + '.webm',
            { type: 'application/octet-stream' }
          )
          
          createContent.append('recording_inteview', d.id)
          console.log('コンテンツ作成データ:', {  // デバッグログ追加
            id: d.id,
            fileName: newFile.name,
            contentData: Object.fromEntries(createContent)
          })
          
          // 他のフィールドを追加
          createContent.append('question_recording', newFile)
          createContent.append('name', content.name)
          createContent.append('description', content.description)
          createContent.append('answer_time', content.answer_time)
          createContent.append('replayable_time', content.replayable_time)
          createContent.append('order', content.order)
          
          return this.$store.dispatch('directtalk/createRecordingContent', createContent)
            .then(() => {
              this.cntCreateLoading()
              console.log('コンテンツ保存成功:', content.name)  // デバッグログ追加
            })
            .catch(error => {
              console.error('コンテンツ保存エラー:', error)  // エラーログ追加
              throw error  // エラーを上位に伝播
            })
        })

        return Promise.all(contentPromises)
          .then(() => {
            console.log('全コンテンツ保存完了')  // デバッグログ追加
            this.isCreatingRecord = false
          })
          .catch(error => {
            console.error('コンテンツ保存中にエラー発生:', error)
            this.isCreatingRecord = false
            // エラー通知を表示
            this.$toast.error('録画データの保存中にエラーが発生しました')
          })
      })
    },
    updateRecordingInterview(data) {
      let updateData = {
        id: data.id,
        name: data.name,
        description: data.description,
        start_hhmm: moment(data.start_hhmm).format('HH:mm:ss'),
        end_hhmm: moment(data.end_hhmm).format('HH:mm:ss'),
        total_limit_time: data.total_limit_time,
        company: data.company,
      }
      this.$store.dispatch('directtalk/updateRecordingInterview', updateData).then((d) => {
        // 差がある場合は削除する
        let deleteArray = this.$_.xorBy(
          this.tempRecordingInterview.recording_content,
          data.recording_content,
          'id'
        )
        for (const delObj of deleteArray) {
          if (delObj.id) {
            this.$store.dispatch('directtalk/deleteRecordingContent', delObj.id)
          }
        }
        for (const content of data.recording_content) {
          let updateContent = new FormData()
          if (typeof content.question_recording === 'object') {
            let newFile = new File(
              [content.question_recording],
              d.id + '-' + createUUID() + '-' + content.order + '.webm',
              { type: 'application/octet-stream' }
            )
            updateContent.append('question_recording', newFile)
          }
          updateContent.append('recording_inteview', d.id)
          updateContent.append('name', content.name)
          updateContent.append('description', content.description)
          updateContent.append('answer_time', content.answer_time)
          updateContent.append('replayable_time', content.replayable_time)
          updateContent.append('order', content.order)
          // Updateか新規かの判定
          if (content.id) {
            updateContent.append('id', content.id)
            this.$store.dispatch('directtalk/updateRecordingContent', updateContent)
          } else {
            this.$store.dispatch('directtalk/createRecordingContent', updateContent)
          }
        }
      })
    },
    updateRecordingAnswer(data) {
      this.$store.dispatch('directtalk/updateRecordingAnswer', data).then((d) => {
        this.$store.dispatch('directtalk/getRecordingInterview', null)
      })
    },
    updateRecordingReadAnswer(data) {
      this.$store.dispatch('directtalk/updateRecordingReadAnswer', data)
    },
    updateRecordingSelectSeeker(data) {
      this.$store.dispatch('directtalk/updateRecordingSelectSeeker', data)
    },
    deleteRecordingInterview(id) {
      this.$store.dispatch('directtalk/deleteRecordingInterview', id)
    },
    changeRecruitmentFlow(skData) {
      let changeSeeker = skData
      this.$store.dispatch('directtalk/updateSeeker', changeSeeker)
    },
  },
}
</script>

<style lang="scss" scoped>
.container-list-width {
  height: 100vh;
  width: calc(100vw - 200px);
}
.container-list-width-thin-menu {
  height: 100vh;
  width: calc(100vw - 55px);
}
.container-list {
  position: relative;
}
.video-header {
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: solid thin #eee;
}
.recording-container {
  height: calc(100% - 64px);
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  //overflow: auto;
  .make-recording {
    cursor: pointer;
    margin: 12px;
    min-width: 280px;
    min-height: 368px;
    width: calc(25% - 24px);
    height: calc(33% - 24px);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    background-image: url('../../../assets/template/webmeeting.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    transition: 0.5s;
    p {
      transition: 0.5s;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
      font-weight: 600;
      padding: 8px 16px;
      background-color: #ffffffdd;
      border: solid 2px #ccc;
      border-radius: 8px;
    }
  }
  .make-recording:hover {
    color: #a22;
    border: solid thin #a22;
    p {
      background-color: #ffffff;
      transform: scale(1.2);
      border: solid 2px #a22;
    }
  }
}
.recording-container::-webkit-scrollbar {
  //width: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VideoView/RecordView.vue